import { render } from "./SubcategoryCreate.vue?vue&type=template&id=dac79422"
import script from "./SubcategoryCreate.vue?vue&type=script&lang=js"
export * from "./SubcategoryCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__